export type HandleValidation = { valid: true } | { valid: false, error: string }

const SEP_RE = /[\s._]+/g
const NON_SAFE_RE = /[^a-z0-9-]+/g
const DASHES_RE = /-+/g
const TRIM_DASH_RE = /^-+|-+$/g

export function normalizeHandle(input: string): string {
  return input
    .trim()
    .replace(SEP_RE, '-')
    .toLowerCase()
    .replace(NON_SAFE_RE, '')
    .replace(DASHES_RE, '-')
    .replace(TRIM_DASH_RE, '')
}

export function validateUsernameHandle(value: string): HandleValidation {
  if (value.length < 4 || value.length > 16) {
    return { valid: false, error: 'username needs 4–16 chars' }
  }
  if (!/^[a-z][a-z0-9-]*$/.test(value)) {
    return { valid: false, error: 'username starts with a letter' }
  }
  return { valid: true }
}

export function validateSpaceSlugHandle(value: string): HandleValidation {
  if (value.length < 4 || value.length > 64) {
    return { valid: false, error: 'space-rename needs 4–64 chars' }
  }
  if (!/^[a-z0-9][a-z0-9-]*$/.test(value)) {
    return { valid: false, error: 'sorry not an URL safe char' }
  }
  return { valid: true }
}
